function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { injectTestId } from "@cvent/nucleus-test-automation";
import XIcon from "../../Icon/X";
import CheckCircleIcon from "../../Icon/CheckCircle";
import AlertTriangleIcon from "../../Icon/AlertTriangle";
import AlertCircleIcon from "../../Icon/AlertCircle";
import InfoIcon from "../../Icon/Info";
import { AlertDismissButton } from "../AlertDismissButton/AlertDismissButton";
import { LiveRegion } from "../LiveRegion/LiveRegion";
export var AlertBase = function(param) {
    var accessibilityLabel = param.accessibilityLabel, accessibilityRole = param.accessibilityRole, accessibilityLive = param.accessibilityLive, _dismissible = param.dismissible, dismissible = _dismissible === void 0 ? true : _dismissible, _appearance = param.appearance, appearance = _appearance === void 0 ? 'info' : _appearance, title = param.title, content = param.content, action = param.action, onDismiss = param.onDismiss, id = param.id, testID = param.testID, _isRtl = param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl, isVisible = param.isVisible, styles = param.styles;
    var container = styles.container, icon = styles.icon, titleContentStyle = styles.titleContent, titleStyle = styles.title, contentActionStyle = styles.contentAction, contentStyle = styles.content, actionStyle = styles.action, dismissStyle = styles.dismiss, dismissButtonStyle = styles.dismissButton;
    return isVisible ? _jsxs(LiveRegion, _objectSpread({
        role: accessibilityRole,
        "aria-live": accessibilityLive,
        "aria-label": accessibilityLabel,
        css: container
    }, injectTestId(testID), {
        children: [
            _jsx("div", {
                css: icon,
                children: getIcon(appearance)
            }),
            _jsxs("div", {
                css: contentActionStyle,
                children: [
                    _jsxs("div", {
                        css: titleContentStyle,
                        children: [
                            title && _jsx("div", {
                                css: titleStyle,
                                children: title
                            }),
                            _jsx("div", {
                                css: contentStyle,
                                children: content
                            })
                        ]
                    }),
                    action && _jsx("div", {
                        css: actionStyle,
                        children: action
                    })
                ]
            }),
            dismissible && _jsx("div", {
                css: dismissStyle,
                children: _jsx(AlertDismissButton, {
                    accessible: true,
                    accessibilityLabel: "Dismiss",
                    appearance: appearance,
                    style: dismissButtonStyle,
                    iconAlign: "end",
                    isRtl: isRtl,
                    testID: "".concat(testID, "-dismiss-button"),
                    icon: XIcon,
                    onClick: function() {
                        return onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss(id);
                    }
                })
            })
        ]
    })) : null;
};
export function getIcon(appearance) {
    var Icons = {
        danger: AlertCircleIcon,
        info: InfoIcon,
        success: CheckCircleIcon,
        warning: AlertTriangleIcon
    };
    var Icon = Icons[appearance];
    return _jsx(Icon, {
        size: "m"
    });
}
